import { render } from "./CustomerTypeEdit.vue?vue&type=template&id=7e498f90"
import script from "./CustomerTypeEdit.vue?vue&type=script&lang=js"
export * from "./CustomerTypeEdit.vue?vue&type=script&lang=js"
script.render = render

export default script